export default __webpack_public_path__ + "static/media/newDoodle.8a0ac104.svg";